import { Editor, Extension } from '@tiptap/core'
import { Node as ProseMirrorNode } from '@tiptap/pm/model'
import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

export interface PlaceholderOptions {
  emptyEditorClass: string
  emptyNodeClass: string
  placeholder: ((PlaceholderProps: { editor: Editor; node: ProseMirrorNode }) => string) | string
  showOnlyWhenEditable: boolean
  showOnlyCurrent: boolean
}

// TODO need to create an issue
//  fix to show placeholder for attribute-dependent nodes(as heading, list)
function isNodeEmpty(node: ProseMirrorNode): boolean {
  // provide node attributes
  const defaultContent = node.type.createAndFill(node.attrs)?.toJSON()
  const content = node.toJSON()

  return JSON.stringify(defaultContent) === JSON.stringify(content)
}

export const Placeholder = Extension.create<PlaceholderOptions>({
  name: 'placeholder',

  addOptions() {
    return {
      emptyEditorClass: 'is-editor-empty',
      emptyNodeClass: 'is-empty',
      placeholder: 'Write something …',
      showOnlyWhenEditable: true,
      showOnlyCurrent: true,
    }
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          decorations: ({ doc, selection }) => {
            const active = this.editor.isEditable || !this.options.showOnlyWhenEditable
            const { anchor } = selection
            const decorations: Decoration[] = []

            if (!active) {
              return
            }

            doc.descendants((node, pos) => {
              const hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize
              // TODO resolve types conflicts between tiptap and prosemirror
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              const isEmpty = !node.isLeaf && isNodeEmpty(node)

              if (hasAnchor && isEmpty) {
                const classes = [this.options.emptyNodeClass]

                if (this.editor.isEmpty) {
                  classes.push(this.options.emptyEditorClass)
                }

                const decoration = Decoration.node(pos, pos + node.nodeSize, {
                  class: classes.join(' '),
                  'data-placeholder':
                    typeof this.options.placeholder === 'function'
                      ? this.options.placeholder({
                          editor: this.editor,
                          // TODO resolve types conflicts between tiptap and prosemirror
                          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                          // @ts-ignore
                          node,
                        })
                      : this.options.placeholder,
                })

                decorations.push(decoration)
              }

              return false
            })

            // eslint-disable-next-line consistent-return
            return DecorationSet.create(doc, decorations)
          },
        },
      }),
    ]
  },
})
